"use strict";
module.exports = {
    entityModel: 'supplierConnection',
    events: {
        SUPPLIER_CONNECTION_REQUESTED: 'SUPPLIER_CONNECTION_REQUESTED',
        SUPPLIER_CONNECTION_IN_PROGRESS: 'SUPPLIER_CONNECTION_IN_PROGRESS',
        SUPPLIER_CONNECTION_CONFIGURED: 'SUPPLIER_CONNECTION_CONFIGURED',
        SUPPLIER_CONNECTION_ACTIVATED: 'SUPPLIER_CONNECTION_ACTIVATED',
        SUPPLIER_CONNECTION_DEACTIVATED: 'SUPPLIER_CONNECTION_DEACTIVATED',
        SUPPLIER_CONNECTION_UPDATED: 'SUPPLIER_CONNECTION_UPDATED',
        SUPPLIER_CONNECTION_CREATED: 'SUPPLIER_CONNECTION_CREATED',
    },
    actions: {
        get: 'v1.supplierConnection.get',
        list: 'v1.supplierConnection.list',
        setDeliveryRules: 'v1.supplierConnection.setDeliveryRules',
        writeSupplierConnection: 'v1.supplierConnection.writeSupplierConnection',
        changeSupplierCustomer: 'v1.supplierConnection.changeSupplierCustomer',
        requestConnection: 'v1.supplierConnection.requestConnection',
        deactivate: 'v1.supplierConnection.deactivate',
        activate: 'v1.supplierConnection.activate',
        completeConfiguration: 'v1.supplierConnection.completeConfiguration',
        startConfiguration: 'v1.supplierConnection.startConfiguration',
        upsert: 'v1.supplierConnection.upsert',
        upsertWhenEmpty: 'v1.supplierConnection.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplierConnection.updateWhenEmpty',
        update: 'v1.supplierConnection.update',
    },
    onboardingStates: {
        'Connection Requested': 'Connection Requested',
        'Connection in progress': 'Connection in progress',
        'Connection configured': 'Connection configured',
    },
    cartTypes: {
        standard: 'standard',
        external: 'external',
    },
};
